<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="col-12 mb-1 d-flex flex-column">
        <mat-slide-toggle
          [(ngModel)]="proofsWithDate"
          (ngModelChange)="filter()"
        >
          ¿Comprobantes clasificados con fecha?
        </mat-slide-toggle>
        <small><strong>Nota:</strong> Los comprobantes anteriores al 27 de mayo de 2025 no tienen registrada su fecha de
          emisión</small>
      </div>

      <input
        [disabled]="!proofsWithDate"
        class="form-control p-sm col-4"
        type="date"
        [(ngModel)]="dateRange.from"
        (ngModelChange)="filter()"
      />
      <input
        [disabled]="!proofsWithDate"
        class="form-control p-sm col-4 ml-1"
        type="date"
        [(ngModel)]="dateRange.to"
        (ngModelChange)="filter()"
      />
    </div>
  </div>
</div>
